<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 19"
  >
    <circle
      cx="9.5"
      cy="9.5"
      r="8.5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <circle
      cx="9.529"
      cy="13.8"
      r="1.2"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      d="M9.067 10.671L8.02 5.655C7.87 4.788 8.574 4 9.5 4c.93 0 1.636.796 1.478 1.666l-1.095 5.008c-.08.436-.74.434-.816-.003Z"
    />
  </svg>
</template>

<script setup>
defineOptions({ name: 'IconAttention' })
</script>
